import React, { useState } from 'react';
import './Footer.css';
import { Button } from './Button';
import { Link } from 'react-router-dom';

function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Simulate subscription
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className='footer-container'>
      {/* Newsletter Section */}
      <section className='footer-subscription'>
        <div className='subscription-content'>
          <h3>Stay Updated</h3>
          <p>Get the latest insights on digital transformation and IT solutions</p>
          <form onSubmit={handleSubscribe} className='subscription-form'>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='Enter your email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button buttonStyle='btn--primary' buttonSize='btn--medium'>
              Subscribe
            </Button>
          </form>
          {subscribed && <p className='subscription-success'>✓ Thank you for subscribing!</p>}
        </div>
      </section>

      {/* Footer Links */}
      <div className='footer-content'>
        <div className='footer-links'>
          <div className='footer-section'>
            <h4>Company</h4>
            <Link to='/'>About Us</Link>
            <Link to='/'>Careers</Link>
            <Link to='/'>Blog</Link>
            <Link to='/'>Press</Link>
          </div>
          <div className='footer-section'>
            <h4>Services</h4>
            <Link to='/products'>Cloud Solutions</Link>
            <Link to='/products'>AI & Analytics</Link>
            <Link to='/products'>DevOps</Link>
            <Link to='/products'>Security</Link>
          </div>
          <div className='footer-section'>
            <h4>Resources</h4>
            <Link to='/'>Documentation</Link>
            <Link to='/'>Support</Link>
            <Link to='/'>Contact</Link>
            <Link to='/'>Pricing</Link>
          </div>
          <div className='footer-section'>
            <h4>Legal</h4>
            <Link to='/terms-conditions'>Terms & Conditions</Link>
            <Link to='/privacy-policy'>Privacy Policy</Link>
            <Link to='/'>Cookie Policy</Link>
            <Link to='/'>GDPR</Link>
          </div>
        </div>

        {/* Social & Copyright */}
        <div className='footer-bottom'>
          <div className='social-section'>
            <span className='social-label'>Follow us</span>
            <div className='social-icons'>
              <a href='https://www.facebook.com/iuriasampaio' target='_blank' rel='noopener noreferrer' aria-label='Facebook'>
                <i className='fab fa-facebook-f' />
              </a>
              <a href='https://x.com/iurixcom' target='_blank' rel='noopener noreferrer' aria-label='Twitter'>
                <i className='fab fa-twitter' />
              </a>
              <a href='https://www.linkedin.com/company/iurix-ai/' target='_blank' rel='noopener noreferrer' aria-label='LinkedIn'>
                <i className='fab fa-linkedin-in' />
              </a>
              <a href='https://github.com/iuri' target='_blank' rel='noopener noreferrer' aria-label='GitHub'>
                <i className='fab fa-github' />
              </a>
            </div>
          </div>
          <div className='copyright'>
            <p>&copy; 2024 IURIX. All rights reserved. | Made with ❤️ for enterprises</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
